import {
  BabaBundle,
  Bagelcode2Bundle,
  BagelcodeBundle,
  BingoPopBundle,
  Candivore2Bundle,
  CandivoreBundle,
  CashmanCasinoBundle,
  ClassicBundle,
  Communix2Bundle,
  CommunixBundle,
  GhostBundle,
  HeartOfVegasBundle,
  JackpotSlotsBundle,
  LightningLinkBundle,
  LightningLinkBundleV2,
  LocoBingoBundle,
  MainSubBundle,
  Me2onBundle,
  MightyFuBundle,
  PipaBundle,
  PlaySimpleBundle,
  WhispersBundle
} from '@appcharge/shared-ui';

import { EBundlesInternalViewModel } from '../constants/enums';

export const mapBundleComponents: Record<EBundlesInternalViewModel, any> = {
  [EBundlesInternalViewModel.AK]: ClassicBundle,
  [EBundlesInternalViewModel.ME2ON]: Me2onBundle,
  [EBundlesInternalViewModel.MAIN_SUB]: MainSubBundle,
  [EBundlesInternalViewModel.COMMUNIX]: CommunixBundle,
  [EBundlesInternalViewModel.COMMUNIX2]: Communix2Bundle,
  [EBundlesInternalViewModel.MATCH]: CandivoreBundle,
  [EBundlesInternalViewModel.BAGELCODE]: BagelcodeBundle,
  [EBundlesInternalViewModel.BAGELCODE2]: Bagelcode2Bundle,
  [EBundlesInternalViewModel.LOCO_BINGO]: LocoBingoBundle,
  [EBundlesInternalViewModel.JACKPOT_SLOTS]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.BIG_FISH_CASINO]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.CASHMAN_CASINO]: CashmanCasinoBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: LightningLinkBundle,
  [EBundlesInternalViewModel.HEART_OF_VEGAS]: HeartOfVegasBundle,
  [EBundlesInternalViewModel.PLAY_SIMPLE]: PlaySimpleBundle,
  [EBundlesInternalViewModel.PIPA]: PipaBundle,
  [EBundlesInternalViewModel.BABA]: BabaBundle,
  [EBundlesInternalViewModel.WHISPERS]: WhispersBundle,
  [EBundlesInternalViewModel.MIGHTY_FU_CASINO]: MightyFuBundle,
  [EBundlesInternalViewModel.CANDIVORE]: Candivore2Bundle,
  [EBundlesInternalViewModel.GHOST]: GhostBundle,
  [EBundlesInternalViewModel.BINGO_POP]: BingoPopBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2]: LightningLinkBundleV2
};
